import { render, staticRenderFns } from "./owner_order.vue?vue&type=template&id=153144b0&scoped=true&"
import script from "./owner_order.vue?vue&type=script&lang=js&"
export * from "./owner_order.vue?vue&type=script&lang=js&"
import style0 from "./owner_order.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./owner_order.vue?vue&type=style&index=1&id=153144b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153144b0",
  null
  
)

export default component.exports